"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateOrganizerAccountEntriesCurrentBalance = exports.getNumberOfOrganizerAccounts = exports.getOrganizerAccounts = exports.getOrganizerById = exports.getLanguages = exports.getTicketTypesByEventId = exports.getTicketTypeNumberOfAvailableTickets = exports.TicketBookableStatus = exports.getTicketTypeInfosByTicketTypeId = exports.Tenant = exports.removeTicketsFromOrder = exports.getShopBasketOrder = exports.getAdmittedPaymentTypesOfOrder = exports.getAdmittedDeliveryMethodsOfOrder = exports.createShopBasketOrder = exports.confirmOrder = exports.changePaymentType = exports.changeDeliveryMethod = exports.removePromotionCode = exports.applyPromotionCode = exports.addTicketsToOrder = exports.PaymentType = exports.updateOptionsOfOrder = exports.getOptionsOfOrder = exports.createOptionsOfOrder = exports.getLocationInfos = exports.getTicketTypeInfoByLanguage = exports.getLocationInfoByLanguage = exports.getFormToolControlOptionInfoByLanguage = exports.getFormToolControlInfoByLanguage = exports.getEventInfoByLanguage = exports.Language = exports.getMappedOrderOptions = exports.getMappedAddress = exports.FormToolField = exports.getFormToolControlsByFormToolId = exports.getFormToolControlOptionsByFormToolControlId = exports.getFormToolControlOptionInfosByFormToolControlId = exports.getFormToolControlInfosByFormToolControlId = exports.FieldControl = exports.getEventList = exports.getEventById = exports.getEventInfosByEventId = exports.getReceiptOfOrder = exports.getPkPassOfTicket = exports.getPdfTicketsOfOrder = exports.DeliveryMethod = exports.DataSaveType = exports.api = exports.updateBuyerAddress = void 0;
exports.deletePointOfSale = exports.patchPointOfSale = exports.postPointOfSale = exports.getNumberOfPointsOfSale = exports.getParentPointsOfSale = exports.getPointsOfSale = exports.getPointOfSale = exports.getCountries = exports.getCountry = exports.getInsuranceChargeTypes = exports.getPaymentMethods = exports.getDeliveryMethods = exports.updateAddress = exports.createAddress = exports.getAddressOfOrder = exports.getAddressOfPointOfSale = exports.getAddressById = exports.getCurrencies = exports.getRegionById = exports.postCrossSellingTicketTypes = exports.getCrossSellingTicketTypesByTicketTypeId = exports.updateTicketTypeInfo = exports.createTicketTypeInfo = exports.updateTicketType = exports.createTicketType = exports.getTurnoverOfTicketType = exports.getNumberOfTicketsSoldOfTicketType = exports.getTicketTypeById = exports.getTicketInsurances = exports.getTicketById = exports.getEventGenreById = exports.saveEventPaymentMethods = exports.getEventInfosByName = exports.updateEventInfo = exports.createEventInfo = exports.updateEvent = exports.getEventIdsOfSeatMap = exports.getEventsForEventCalculationDefinitions = exports.getEventsForDeliveryPaymentFees = exports.getTurnoverOfEvent = exports.getNumberOfTicketsSoldOfEvent = exports.getOrderOfPayment = exports.getOrder = exports.getOrders = exports.deleteOrganizerAccountTransaction = exports.putOrganizerAccountTransaction = exports.getOrganizerAccountTransaction = exports.getNumberOfOrganizerAccountTransactions = exports.getOrganizerAccountTransactions = exports.deleteOrganizerAccount = void 0;
exports.updateRows = exports.createRows = exports.getRowsByZoneId = exports.deleteZone = exports.updateZoneImage = exports.putZone = exports.createZone = exports.getZone = exports.getZonesBySeatMapId = exports.getSeatMaps = exports.getSeatMapOfEvent = exports.deleteSeatMap = exports.updateSeatMapImage = exports.putSeatMap = exports.postSeatMap = exports.getSeatMapById = exports.putLocationInfo = exports.postLocationInfo = exports.putLocation = exports.postLocation = exports.getLocationById = exports.deleteLocation = exports.getLocations = exports.getLocationTypes = exports.createDefaultEventCalculationDefinitionsForEvent = exports.createDefaultEventCalculationDefinitionsForOrganizer = exports.deleteEventCalculationDefinitionsOfEvent = exports.deleteEventCalculationDefinitionsOfOrganizer = exports.deleteEventCalculationDefinition = exports.putEventCalculationDefinition = exports.postEventCalculationDefinition = exports.getNumberOfEventCalculationDefinitionsByEventId = exports.getNumberOfEventCalculationDefinitionsByOrganizerId = exports.getEventCalculationDefinitionsByEventId = exports.getEventCalculationDefinitionsByOrganizerId = exports.getEventCalculationDefinition = exports.deleteCurrencyConversion = exports.putCurrencyConversion = exports.postCurrencyConversion = exports.getCurrencyConversions = exports.getCurrencyConversion = exports.deleteDeliveryPaymentFee = exports.putDeliveryPaymentFee = exports.postDeliveryPaymentFee = exports.getNumberOfDeliveryPaymentFees = exports.getDeliveryPaymentFees = exports.getDeliveryPaymentFee = exports.getPointOfSaleChargeGroups = exports.putPaymentMethodIdsOfPointOfSale = exports.getPaymentMethodIdsOfPointOfSale = void 0;
exports.getRevenueGroups = exports.getEventCalculationEvents = exports.getTransactionTypes = exports.getSeatMapShapesOfZone = exports.deleteZoneEvent = exports.createZoneEvent = exports.getZoneEventsOfEvent = exports.getSeatMapShapes = exports.getSeatStatuses = exports.deleteSeats = exports.removeTicketTypeFromSeats = exports.addTicketTypeToSeats = exports.updateStatusOfSeats = exports.updateSeats = exports.createSeats = exports.getSeatsOfZone = exports.deleteRows = void 0;
const axios_instance_1 = require("./axios-instance");
var requests_1 = require("./addresses/requests");
Object.defineProperty(exports, "updateBuyerAddress", { enumerable: true, get: function () { return requests_1.updateBuyerAddress; } });
var axios_instance_2 = require("./axios-instance");
Object.defineProperty(exports, "api", { enumerable: true, get: function () { return axios_instance_2.api; } });
//data save types
var enums_1 = require("./dataSaveTypes/enums");
Object.defineProperty(exports, "DataSaveType", { enumerable: true, get: function () { return enums_1.DataSaveType; } });
//payment types
var enums_2 = require("./deliveryMethods/enums");
Object.defineProperty(exports, "DeliveryMethod", { enumerable: true, get: function () { return enums_2.DeliveryMethod; } });
//documents
var requests_2 = require("./documents/requests");
Object.defineProperty(exports, "getPdfTicketsOfOrder", { enumerable: true, get: function () { return requests_2.getPdfTicketsOfOrder; } });
Object.defineProperty(exports, "getPkPassOfTicket", { enumerable: true, get: function () { return requests_2.getPkPassOfTicket; } });
Object.defineProperty(exports, "getReceiptOfOrder", { enumerable: true, get: function () { return requests_2.getReceiptOfOrder; } });
//event infos
var requests_3 = require("./eventInfos/requests");
Object.defineProperty(exports, "getEventInfosByEventId", { enumerable: true, get: function () { return requests_3.getEventInfosByEventId; } });
//events
var requests_4 = require("./events/requests");
Object.defineProperty(exports, "getEventById", { enumerable: true, get: function () { return requests_4.getEventById; } });
Object.defineProperty(exports, "getEventList", { enumerable: true, get: function () { return requests_4.getEventList; } });
//field controls
var enums_3 = require("./fieldControls/enums");
Object.defineProperty(exports, "FieldControl", { enumerable: true, get: function () { return enums_3.FieldControl; } });
//form tool control infos
var requests_5 = require("./formToolControlInfos/requests");
Object.defineProperty(exports, "getFormToolControlInfosByFormToolControlId", { enumerable: true, get: function () { return requests_5.getFormToolControlInfosByFormToolControlId; } });
//form tool control option infos
var requests_6 = require("./formToolControlOptionInfos/requests");
Object.defineProperty(exports, "getFormToolControlOptionInfosByFormToolControlId", { enumerable: true, get: function () { return requests_6.getFormToolControlOptionInfosByFormToolControlId; } });
//form tool control options
var requests_7 = require("./formToolControlOptions/requests");
Object.defineProperty(exports, "getFormToolControlOptionsByFormToolControlId", { enumerable: true, get: function () { return requests_7.getFormToolControlOptionsByFormToolControlId; } });
//form tool controls
var requests_8 = require("./formToolControls/requests");
Object.defineProperty(exports, "getFormToolControlsByFormToolId", { enumerable: true, get: function () { return requests_8.getFormToolControlsByFormToolId; } });
//form tool fields
var enums_4 = require("./formToolFields/enums");
Object.defineProperty(exports, "FormToolField", { enumerable: true, get: function () { return enums_4.FormToolField; } });
var extensions_1 = require("./formToolFields/extensions");
Object.defineProperty(exports, "getMappedAddress", { enumerable: true, get: function () { return extensions_1.getMappedAddress; } });
Object.defineProperty(exports, "getMappedOrderOptions", { enumerable: true, get: function () { return extensions_1.getMappedOrderOptions; } });
// language
var enums_5 = require("./languages/enums");
Object.defineProperty(exports, "Language", { enumerable: true, get: function () { return enums_5.Language; } });
var extensions_2 = require("./languages/extensions");
Object.defineProperty(exports, "getEventInfoByLanguage", { enumerable: true, get: function () { return extensions_2.getEventInfoByLanguage; } });
Object.defineProperty(exports, "getFormToolControlInfoByLanguage", { enumerable: true, get: function () { return extensions_2.getFormToolControlInfoByLanguage; } });
Object.defineProperty(exports, "getFormToolControlOptionInfoByLanguage", { enumerable: true, get: function () { return extensions_2.getFormToolControlOptionInfoByLanguage; } });
Object.defineProperty(exports, "getLocationInfoByLanguage", { enumerable: true, get: function () { return extensions_2.getLocationInfoByLanguage; } });
Object.defineProperty(exports, "getTicketTypeInfoByLanguage", { enumerable: true, get: function () { return extensions_2.getTicketTypeInfoByLanguage; } });
//form tool controls
var requests_9 = require("./locationInfos/requests");
Object.defineProperty(exports, "getLocationInfos", { enumerable: true, get: function () { return requests_9.getLocationInfos; } });
// order options
var requests_10 = require("./orderOptions/requests");
Object.defineProperty(exports, "createOptionsOfOrder", { enumerable: true, get: function () { return requests_10.createOptionsOfOrder; } });
Object.defineProperty(exports, "getOptionsOfOrder", { enumerable: true, get: function () { return requests_10.getOptionsOfOrder; } });
Object.defineProperty(exports, "updateOptionsOfOrder", { enumerable: true, get: function () { return requests_10.updateOptionsOfOrder; } });
//payment types
var enums_6 = require("./paymentTypes/enums");
Object.defineProperty(exports, "PaymentType", { enumerable: true, get: function () { return enums_6.PaymentType; } });
//shop basket
var requests_11 = require("./shopBasket/requests");
Object.defineProperty(exports, "addTicketsToOrder", { enumerable: true, get: function () { return requests_11.addTicketsToOrder; } });
Object.defineProperty(exports, "applyPromotionCode", { enumerable: true, get: function () { return requests_11.applyPromotionCode; } });
Object.defineProperty(exports, "removePromotionCode", { enumerable: true, get: function () { return requests_11.removePromotionCode; } });
Object.defineProperty(exports, "changeDeliveryMethod", { enumerable: true, get: function () { return requests_11.changeDeliveryMethod; } });
Object.defineProperty(exports, "changePaymentType", { enumerable: true, get: function () { return requests_11.changePaymentType; } });
Object.defineProperty(exports, "confirmOrder", { enumerable: true, get: function () { return requests_11.confirmOrder; } });
Object.defineProperty(exports, "createShopBasketOrder", { enumerable: true, get: function () { return requests_11.createShopBasketOrder; } });
Object.defineProperty(exports, "getAdmittedDeliveryMethodsOfOrder", { enumerable: true, get: function () { return requests_11.getAdmittedDeliveryMethodsOfOrder; } });
Object.defineProperty(exports, "getAdmittedPaymentTypesOfOrder", { enumerable: true, get: function () { return requests_11.getAdmittedPaymentTypesOfOrder; } });
Object.defineProperty(exports, "getShopBasketOrder", { enumerable: true, get: function () { return requests_11.getShopBasketOrder; } });
Object.defineProperty(exports, "removeTicketsFromOrder", { enumerable: true, get: function () { return requests_11.removeTicketsFromOrder; } });
//tenants
var enums_7 = require("./tenants/enums");
Object.defineProperty(exports, "Tenant", { enumerable: true, get: function () { return enums_7.Tenant; } });
//ticket type infos
var requests_12 = require("./ticketTypeInfos/requests");
Object.defineProperty(exports, "getTicketTypeInfosByTicketTypeId", { enumerable: true, get: function () { return requests_12.getTicketTypeInfosByTicketTypeId; } });
var enums_8 = require("./ticketTypes/enums");
Object.defineProperty(exports, "TicketBookableStatus", { enumerable: true, get: function () { return enums_8.TicketBookableStatus; } });
//ticket types
var requests_13 = require("./ticketTypes/requests");
Object.defineProperty(exports, "getTicketTypeNumberOfAvailableTickets", { enumerable: true, get: function () { return requests_13.getTicketTypeNumberOfAvailableTickets; } });
Object.defineProperty(exports, "getTicketTypesByEventId", { enumerable: true, get: function () { return requests_13.getTicketTypesByEventId; } });
/**
 * Language
 */
function getLanguages() {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get("/Languages");
        return response.data.languages;
    });
}
exports.getLanguages = getLanguages;
/**
 * Organizer
 */
function getOrganizerById(organizerId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/Organizer/${organizerId}`);
        return response.data;
    });
}
exports.getOrganizerById = getOrganizerById;
/**
 * OrganizerAccount
 */
function getOrganizerAccounts(organizerId, numberToTake = 10, numberToSkip = 0) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get("/OrganizerAccounts", { params: { organizerId, numberToTake, numberToSkip } });
        return response.data.organizerAccounts;
    });
}
exports.getOrganizerAccounts = getOrganizerAccounts;
function getNumberOfOrganizerAccounts(organizerId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get("/OrganizerAccounts/Count", { params: { organizerId } });
        return response.data;
    });
}
exports.getNumberOfOrganizerAccounts = getNumberOfOrganizerAccounts;
function updateOrganizerAccountEntriesCurrentBalance(organizerAccountId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.put(`/OrganizerAccount/${organizerAccountId}/Balance`);
        return response.data;
    });
}
exports.updateOrganizerAccountEntriesCurrentBalance = updateOrganizerAccountEntriesCurrentBalance;
function deleteOrganizerAccount(organizerAccountId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.delete(`/OrganizerAccount/${organizerAccountId}`);
        return response.data;
    });
}
exports.deleteOrganizerAccount = deleteOrganizerAccount;
/**
 * OrganizerAccountTransactions
 */
function getOrganizerAccountTransactions(organizerAccountId, { fromDate = null, toDate = null, eventId = null, transactionTypeId = null, numberToTake = 100, numberToSkip = 0, parentTransactionId = null, searchRelatedTransactions = null, } = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/OrganizerAccount/${organizerAccountId}/Transactions`, {
            params: {
                fromDate,
                toDate,
                eventId,
                transactionTypeId,
                numberToTake,
                numberToSkip,
                parentTransactionId,
                searchRelatedTransactions,
            },
        });
        return response.data.organizerAccountTransactions;
    });
}
exports.getOrganizerAccountTransactions = getOrganizerAccountTransactions;
function getNumberOfOrganizerAccountTransactions(organizerAccountId, { fromDate = null, toDate = null, eventId = null, transactionTypeId = null, parentTransactionId = null, searchRelatedTransactions = null } = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/OrganizerAccount/${organizerAccountId}/Transactions/Count`, {
            params: {
                fromDate,
                toDate,
                eventId,
                transactionTypeId,
                parentTransactionId,
                searchRelatedTransactions,
            },
        });
        return response.data;
    });
}
exports.getNumberOfOrganizerAccountTransactions = getNumberOfOrganizerAccountTransactions;
function getOrganizerAccountTransaction(currencyConversionId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/OrganizerAccountTransaction/${currencyConversionId}`);
        return response.data;
    });
}
exports.getOrganizerAccountTransaction = getOrganizerAccountTransaction;
function putOrganizerAccountTransaction(currencyConversionId, currencyConversion = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.put(`/OrganizerAccountTransaction/${currencyConversionId}`, currencyConversion);
        return response.data;
    });
}
exports.putOrganizerAccountTransaction = putOrganizerAccountTransaction;
function deleteOrganizerAccountTransaction(currencyConversionId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.delete(`/OrganizerAccountTransaction/${currencyConversionId}`);
        return response.data;
    });
}
exports.deleteOrganizerAccountTransaction = deleteOrganizerAccountTransaction;
/**
 * Order
 */
function getOrders({ organizerId = null, eventId = null, includeCancelledOrders = null, filterText = null, dataTransReferenceId = null, fromDate = null, toDate = null, fromAmount = null, toAmount = null, numberToSkip = null, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get("/Orders", {
            params: { organizerId, eventId, includeCancelledOrders, filterText, dataTransReferenceId, fromDate, toDate, fromAmount, toAmount, numberToSkip },
        });
        return response.data.orderList;
    });
}
exports.getOrders = getOrders;
function getOrder(orderId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/Order/${orderId}`);
        return response.data;
    });
}
exports.getOrder = getOrder;
function getOrderOfPayment(referenceNumber) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/Payment/${referenceNumber}/Order`);
        return response.data;
    });
}
exports.getOrderOfPayment = getOrderOfPayment;
/**
 * Event
 */
function getNumberOfTicketsSoldOfEvent(eventId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/Event/${eventId}/TicketsSold`);
        return response.data;
    });
}
exports.getNumberOfTicketsSoldOfEvent = getNumberOfTicketsSoldOfEvent;
function getTurnoverOfEvent(eventId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/Event/${eventId}/Turnover`);
        return response.data;
    });
}
exports.getTurnoverOfEvent = getTurnoverOfEvent;
function getEventsForDeliveryPaymentFees(organizerId, languageCode) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield axios_instance_1.api.get("/DeliveryPaymentFees/Events", {
            params: { organizerId, languageCode },
        });
        return data.events;
    });
}
exports.getEventsForDeliveryPaymentFees = getEventsForDeliveryPaymentFees;
function getEventsForEventCalculationDefinitions(organizerId, languageCode) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get("/EventCalculationDefinitions/Events", { params: { organizerId, languageCode } });
        return response.data.events;
    });
}
exports.getEventsForEventCalculationDefinitions = getEventsForEventCalculationDefinitions;
function getEventIdsOfSeatMap(seatMapId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/Seatmap/${seatMapId}/Events`);
        return response.data;
    });
}
exports.getEventIdsOfSeatMap = getEventIdsOfSeatMap;
function updateEvent(event) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.put("/Event", event);
        return response.data;
    });
}
exports.updateEvent = updateEvent;
/**
 * EventInfos
 */
function createEventInfo(eventInfo = { id: 0, eventId: 0 }) {
    return __awaiter(this, void 0, void 0, function* () {
        eventInfo.id = 0;
        const response = yield axios_instance_1.api.post(`/Event/${eventInfo.eventId}/Info`, eventInfo);
        return response.data;
    });
}
exports.createEventInfo = createEventInfo;
function updateEventInfo(eventInfo = { eventId: 0 }) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.put(`/Event/${eventInfo.eventId}/Info`, eventInfo);
        return response.data;
    });
}
exports.updateEventInfo = updateEventInfo;
function getEventInfosByName({ languageCode, filter, cancelToken }) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/EventInfos/${languageCode}/${filter}/CrossSelling`, {
            cancelToken,
        });
        return response.data;
    });
}
exports.getEventInfosByName = getEventInfosByName;
/**
 * EventPaymentMethods
 */
function saveEventPaymentMethods(eventId, paymentMethodGroupIds) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.put(`/Event/${eventId}/PaymentMethods`, paymentMethodGroupIds);
        return response.data;
    });
}
exports.saveEventPaymentMethods = saveEventPaymentMethods;
/**
 * EventGenre
 */
function getEventGenreById(eventGenreId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/EventGenre/${eventGenreId}`);
        return response.data;
    });
}
exports.getEventGenreById = getEventGenreById;
/**
 * Ticket
 */
function getTicketById(ticketId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/Ticket/${ticketId}`);
        return response.data;
    });
}
exports.getTicketById = getTicketById;
function getTicketInsurances(fromDate, toDate) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get("/Tickets/Insurances", {
            params: {
                fromDate: fromDate.toISOString().split("T")[0],
                toDate: toDate.toISOString().split("T")[0],
            },
        });
        return response.data;
    });
}
exports.getTicketInsurances = getTicketInsurances;
/**
 * TicketType
 */
function getTicketTypeById(ticketTypeId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/TicketType/${ticketTypeId}`);
        return response.data;
    });
}
exports.getTicketTypeById = getTicketTypeById;
function getNumberOfTicketsSoldOfTicketType(ticketTypeId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/TicketType/${ticketTypeId}/TicketsSold`);
        return response.data;
    });
}
exports.getNumberOfTicketsSoldOfTicketType = getNumberOfTicketsSoldOfTicketType;
function getTurnoverOfTicketType(ticketTypeId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/TicketType/${ticketTypeId}/Turnover`);
        return response.data;
    });
}
exports.getTurnoverOfTicketType = getTurnoverOfTicketType;
function createTicketType(ticketType = { id: 0 }) {
    return __awaiter(this, void 0, void 0, function* () {
        ticketType.id = 0;
        const response = yield axios_instance_1.api.post(`/TicketType`, ticketType);
        return response.data;
    });
}
exports.createTicketType = createTicketType;
function updateTicketType(ticketType = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.put(`/TicketType`, ticketType);
        return response.data;
    });
}
exports.updateTicketType = updateTicketType;
/**
 * TicketTypeInfo
 */
function createTicketTypeInfo(ticketTypeInfo = { id: 0, ticketTypeId: 0 }) {
    return __awaiter(this, void 0, void 0, function* () {
        ticketTypeInfo.id = 0;
        const response = yield axios_instance_1.api.post(`/TicketTypeInfo`, ticketTypeInfo);
        return response.data;
    });
}
exports.createTicketTypeInfo = createTicketTypeInfo;
function updateTicketTypeInfo(ticketTypeInfo = { id: 0, ticketTypeId: 0 }) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.put(`/TicketTypeInfo/${ticketTypeInfo.id}`, ticketTypeInfo);
        return response.data;
    });
}
exports.updateTicketTypeInfo = updateTicketTypeInfo;
/**
 * CrossSellingTicketType
 */
function getCrossSellingTicketTypesByTicketTypeId(ticketTypeId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/TicketType/${ticketTypeId}/CrossSelling`);
        return response.data;
    });
}
exports.getCrossSellingTicketTypesByTicketTypeId = getCrossSellingTicketTypesByTicketTypeId;
function postCrossSellingTicketTypes(ticketTypeId, recommendedTicketTypeIds) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.post(`/TicketType/${ticketTypeId}/CrossSelling`, recommendedTicketTypeIds);
        return response.data;
    });
}
exports.postCrossSellingTicketTypes = postCrossSellingTicketTypes;
/**
 * Region
 */
function getRegionById(regionId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/Region/${regionId}`);
        return response.data;
    });
}
exports.getRegionById = getRegionById;
/**
 * Currency
 */
function getCurrencies(tenantId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get("/Currencies", { params: { tenantId } });
        return response.data.currencies;
    });
}
exports.getCurrencies = getCurrencies;
/**
 * Address
 */
function getAddressById(addressId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/Address/${addressId}`);
        return response.data;
    });
}
exports.getAddressById = getAddressById;
function getAddressOfPointOfSale(pointOfSaleId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/PointOfSale/${pointOfSaleId}/Address`);
        return response.data;
    });
}
exports.getAddressOfPointOfSale = getAddressOfPointOfSale;
function getAddressOfOrder(orderId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/Order/${orderId}/Address`);
        return response.data;
    });
}
exports.getAddressOfOrder = getAddressOfOrder;
function createAddress(address = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.post(`/Address`, address);
        return response.data;
    });
}
exports.createAddress = createAddress;
function updateAddress(address = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.put(`/Address`, address);
        return response.data;
    });
}
exports.updateAddress = updateAddress;
/**
 * DeliveryMethod
 */
function getDeliveryMethods(languageCode) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get("/DeliveryMethods", { params: { languageCode } });
        return response.data.deliveryMethods;
    });
}
exports.getDeliveryMethods = getDeliveryMethods;
/**
 * PaymentMethod
 */
function getPaymentMethods(languageCode) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get("/PaymentMethods", { params: { languageCode } });
        return response.data.paymentMethods;
    });
}
exports.getPaymentMethods = getPaymentMethods;
/**
 * InsuranceChargeType
 */
function getInsuranceChargeTypes(languageCode) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get("/InsuranceChargeTypes", { params: { languageCode } });
        return response.data.insuranceChargeTypes;
    });
}
exports.getInsuranceChargeTypes = getInsuranceChargeTypes;
/**
 * Country
 */
function getCountry(countryId, languageCode) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/Country/${countryId}`, { params: { languageCode } });
        return response.data;
    });
}
exports.getCountry = getCountry;
function getCountries(languageCode) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get("/Countries", { params: { languageCode } });
        return response.data;
    });
}
exports.getCountries = getCountries;
/**
 * PointOfSale
 */
function getPointOfSale(pointOfSaleId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/PointOfSale/${pointOfSaleId}`);
        return response.data;
    });
}
exports.getPointOfSale = getPointOfSale;
function getPointsOfSale({ organizerId = null, filter = "", parentId = null, addressId = null, includeInactivePos = true, numberToTake = 100, numberToSkip = 0, cancelToken }) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get("/PointsOfSale", {
            params: { organizerId, filter, parentId, addressId, includeInactivePos, numberToTake, numberToSkip },
            cancelToken,
        });
        return response.data.posList;
    });
}
exports.getPointsOfSale = getPointsOfSale;
function getParentPointsOfSale() {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get("/ParentPointsOfSale");
        return response.data.posList;
    });
}
exports.getParentPointsOfSale = getParentPointsOfSale;
function getNumberOfPointsOfSale({ organizerId = null, filter = "", parentId = null, addressId = null, includeInactivePos = true, } = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get("/PointsOfSale/Count", {
            params: { organizerId, filter, parentId, addressId, includeInactivePos },
        });
        return response.data;
    });
}
exports.getNumberOfPointsOfSale = getNumberOfPointsOfSale;
function postPointOfSale(pointOfSale = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.post("/PointOfSale", pointOfSale);
        return response.data;
    });
}
exports.postPointOfSale = postPointOfSale;
function patchPointOfSale(pointOfSaleId = {}, patchData = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.patch(`/PointOfSale/${pointOfSaleId}`, patchData);
        return response.data;
    });
}
exports.patchPointOfSale = patchPointOfSale;
function deletePointOfSale(pointOfSaleId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.delete(`/PointOfSale/${pointOfSaleId}`);
        return response.data;
    });
}
exports.deletePointOfSale = deletePointOfSale;
/**
 * PointOfSalePaymentMethod
 */
function getPaymentMethodIdsOfPointOfSale(pointOfSaleId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/PointOfSale/${pointOfSaleId}/PaymentMethods`);
        return response.data;
    });
}
exports.getPaymentMethodIdsOfPointOfSale = getPaymentMethodIdsOfPointOfSale;
function putPaymentMethodIdsOfPointOfSale(pointOfSaleId, paymentMethodIds) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.put(`/PointOfSale/${pointOfSaleId}/PaymentMethods`, paymentMethodIds);
        return response.data;
    });
}
exports.putPaymentMethodIdsOfPointOfSale = putPaymentMethodIdsOfPointOfSale;
/**
 * PointOfSaleChargeGroup
 */
function getPointOfSaleChargeGroups() {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/PointOfSaleChargeGroups`);
        return response.data.pointOfSaleChargeGroups;
    });
}
exports.getPointOfSaleChargeGroups = getPointOfSaleChargeGroups;
/**
 * DeliveryPaymentFee
 */
function getDeliveryPaymentFee(deliveryPaymentFeeId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/DeliveryPaymentFee/${deliveryPaymentFeeId}`);
        return response.data;
    });
}
exports.getDeliveryPaymentFee = getDeliveryPaymentFee;
function getDeliveryPaymentFees(params = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get("/DeliveryPaymentFees", { params });
        return response.data;
    });
}
exports.getDeliveryPaymentFees = getDeliveryPaymentFees;
function getNumberOfDeliveryPaymentFees(params = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get("/DeliveryPaymentFees/Count", { params });
        return response.data;
    });
}
exports.getNumberOfDeliveryPaymentFees = getNumberOfDeliveryPaymentFees;
function postDeliveryPaymentFee(deliveryPaymentFee = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.post("/DeliveryPaymentFee", deliveryPaymentFee);
        return response.data;
    });
}
exports.postDeliveryPaymentFee = postDeliveryPaymentFee;
function putDeliveryPaymentFee(deliveryPaymentFeeId, deliveryPaymentFee = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.put(`/DeliveryPaymentFee/${deliveryPaymentFeeId}`, deliveryPaymentFee);
        return response.data;
    });
}
exports.putDeliveryPaymentFee = putDeliveryPaymentFee;
function deleteDeliveryPaymentFee(deliveryPaymentFeeId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.delete(`/DeliveryPaymentFee/${deliveryPaymentFeeId}`);
        return response.data;
    });
}
exports.deleteDeliveryPaymentFee = deleteDeliveryPaymentFee;
/**
 * CurrencyConversion
 */
function getCurrencyConversion(currencyConversionId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/CurrencyConversion/${currencyConversionId}`);
        return response.data;
    });
}
exports.getCurrencyConversion = getCurrencyConversion;
function getCurrencyConversions() {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get("/CurrencyConversions");
        return response.data.currencyConversions;
    });
}
exports.getCurrencyConversions = getCurrencyConversions;
function postCurrencyConversion(currencyConversion = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.post("/CurrencyConversion", currencyConversion);
        return response.data;
    });
}
exports.postCurrencyConversion = postCurrencyConversion;
function putCurrencyConversion(currencyConversionId, currencyConversion = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.put(`/CurrencyConversion/${currencyConversionId}`, currencyConversion);
        return response.data;
    });
}
exports.putCurrencyConversion = putCurrencyConversion;
function deleteCurrencyConversion(currencyConversionId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.delete(`/CurrencyConversion/${currencyConversionId}`);
        return response.data;
    });
}
exports.deleteCurrencyConversion = deleteCurrencyConversion;
/**
 * EventCalculationDefinitions
 */
function getEventCalculationDefinition(eventCalculationDefinitionId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/EventCalculationDefinition/${eventCalculationDefinitionId}`);
        return response.data;
    });
}
exports.getEventCalculationDefinition = getEventCalculationDefinition;
function getEventCalculationDefinitionsByOrganizerId(organizerId, numberToTake, numberToSkip = 0) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get("/EventCalculationDefinitions", {
            params: { organizerId, numberToTake, numberToSkip },
        });
        return response.data.eventCalculationDefinitions;
    });
}
exports.getEventCalculationDefinitionsByOrganizerId = getEventCalculationDefinitionsByOrganizerId;
function getEventCalculationDefinitionsByEventId(eventId, numberToTake, numberToSkip = 0) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get("/EventCalculationDefinitions", {
            params: { eventId, numberToTake, numberToSkip },
        });
        return response.data.eventCalculationDefinitions;
    });
}
exports.getEventCalculationDefinitionsByEventId = getEventCalculationDefinitionsByEventId;
function getNumberOfEventCalculationDefinitionsByOrganizerId(organizerId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get("/EventCalculationDefinitions/Count", { params: { organizerId } });
        return response.data;
    });
}
exports.getNumberOfEventCalculationDefinitionsByOrganizerId = getNumberOfEventCalculationDefinitionsByOrganizerId;
function getNumberOfEventCalculationDefinitionsByEventId(eventId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get("/EventCalculationDefinitions/Count", { params: { eventId } });
        return response.data;
    });
}
exports.getNumberOfEventCalculationDefinitionsByEventId = getNumberOfEventCalculationDefinitionsByEventId;
function postEventCalculationDefinition(eventCalculationDefinition = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.post("/EventCalculationDefinition", eventCalculationDefinition);
        return response.data;
    });
}
exports.postEventCalculationDefinition = postEventCalculationDefinition;
function putEventCalculationDefinition(eventCalculationDefinitionId, eventCalculationDefinition = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.put(`/EventCalculationDefinition/${eventCalculationDefinitionId}`, eventCalculationDefinition);
        return response.data;
    });
}
exports.putEventCalculationDefinition = putEventCalculationDefinition;
function deleteEventCalculationDefinition(eventCalculationDefinitionId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.delete(`/EventCalculationDefinition/${eventCalculationDefinitionId}`);
        return response.data;
    });
}
exports.deleteEventCalculationDefinition = deleteEventCalculationDefinition;
function deleteEventCalculationDefinitionsOfOrganizer(organizerId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.delete(`/Organizer/${organizerId}/EventCalculationDefinitions`);
        return response.data;
    });
}
exports.deleteEventCalculationDefinitionsOfOrganizer = deleteEventCalculationDefinitionsOfOrganizer;
function deleteEventCalculationDefinitionsOfEvent(eventId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.delete(`/Event/${eventId}/EventCalculationDefinitions`);
        return response.data;
    });
}
exports.deleteEventCalculationDefinitionsOfEvent = deleteEventCalculationDefinitionsOfEvent;
function createDefaultEventCalculationDefinitionsForOrganizer(organizerId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.post(`/Organizer/${organizerId}/EventCalculationDefinitions`);
        return response.data;
    });
}
exports.createDefaultEventCalculationDefinitionsForOrganizer = createDefaultEventCalculationDefinitionsForOrganizer;
function createDefaultEventCalculationDefinitionsForEvent(eventId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.post(`/Event/${eventId}/EventCalculationDefinitions`);
        return response.data;
    });
}
exports.createDefaultEventCalculationDefinitionsForEvent = createDefaultEventCalculationDefinitionsForEvent;
/*
 * LocationsOverview
 */
function getLocationTypes() {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/Location/Types`);
        return response.data.locationTypes;
    });
}
exports.getLocationTypes = getLocationTypes;
function getLocations(locationTypeId, numberToTake, numberToSkip) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get("/Locations", { params: { locationTypeId, numberToTake, numberToSkip } });
        return response.data.locations;
    });
}
exports.getLocations = getLocations;
function deleteLocation(locationId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.delete(`/Location/${locationId}`);
        return response.data;
    });
}
exports.deleteLocation = deleteLocation;
function getLocationById(locationId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get("/Location", { params: { locationId } });
        return response.data;
    });
}
exports.getLocationById = getLocationById;
function postLocation(newLocation = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.post("/Location", newLocation);
        return response.data;
    });
}
exports.postLocation = postLocation;
function putLocation(updatedLocation = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.put("/Location", updatedLocation);
        return response.data;
    });
}
exports.putLocation = putLocation;
function postLocationInfo(newLocationInfo = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.post("/Location/Info", newLocationInfo);
        return response.data;
    });
}
exports.postLocationInfo = postLocationInfo;
function putLocationInfo(updatedLocationInfo = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.put("/Location/Info", updatedLocationInfo);
        return response.data;
    });
}
exports.putLocationInfo = putLocationInfo;
/**
 * SeatMap
 */
function getSeatMapById(seatMapId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/SeatMap/${seatMapId}`);
        return response.data;
    });
}
exports.getSeatMapById = getSeatMapById;
function postSeatMap(seatMap) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.post("/SeatMap", seatMap);
        return response.data;
    });
}
exports.postSeatMap = postSeatMap;
function putSeatMap(seatMapId, seatMap) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.put(`/SeatMap/${seatMapId}`, seatMap);
        return response.data;
    });
}
exports.putSeatMap = putSeatMap;
function updateSeatMapImage(seatMapId, originalImageData) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.put(`/SeatMap/${seatMapId}/Image`, { originalImageData });
        return response.data;
    });
}
exports.updateSeatMapImage = updateSeatMapImage;
function deleteSeatMap(seatMapId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.delete(`/SeatMap/${seatMapId}`);
        return response.data;
    });
}
exports.deleteSeatMap = deleteSeatMap;
function getSeatMapOfEvent(eventId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/Event/${eventId}/SeatMap`);
        return response.data;
    });
}
exports.getSeatMapOfEvent = getSeatMapOfEvent;
function getSeatMaps(filterText, locationId, numberToTake, numberToSkip) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/Seatmaps`, {
            params: { filterText, locationId, numberToTake, numberToSkip },
        });
        return response.data;
    });
}
exports.getSeatMaps = getSeatMaps;
/**
 * Zone
 */
function getZonesBySeatMapId(seatMapId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/SeatMap/${seatMapId}/Zones`);
        return response.data.zones;
    });
}
exports.getZonesBySeatMapId = getZonesBySeatMapId;
function getZone(zoneId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/Zone/${zoneId}`);
        return response.data;
    });
}
exports.getZone = getZone;
function createZone(zone) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.post("/Zone", zone);
        return response.data;
    });
}
exports.createZone = createZone;
function putZone(zone) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.put("/Zone", zone);
        return response.data;
    });
}
exports.putZone = putZone;
function updateZoneImage(zoneId, originalImageData) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.put(`/Zone/${zoneId}/Image`, { originalImageData });
        return response.data;
    });
}
exports.updateZoneImage = updateZoneImage;
function deleteZone(zoneId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.delete(`/Zone/${zoneId}`);
        return response.data;
    });
}
exports.deleteZone = deleteZone;
/**
 * Row
 */
function getRowsByZoneId(zoneId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/Zone/${zoneId}/Rows`);
        return response.data;
    });
}
exports.getRowsByZoneId = getRowsByZoneId;
function createRows(zoneId, rows) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.post(`/Zone/${zoneId}/Rows`, rows);
        return response.data;
    });
}
exports.createRows = createRows;
function updateRows(zoneId, rows) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.put(`/Zone/${zoneId}/Rows`, rows);
        return response.data;
    });
}
exports.updateRows = updateRows;
function deleteRows(rowIds) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.delete(`/Rows`, { data: rowIds });
        return response.data;
    });
}
exports.deleteRows = deleteRows;
/**
 * Seat
 */
function getSeatsOfZone(zoneId, eventId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/Zone/${zoneId}/Seats`, { params: { eventId } });
        return response.data;
    });
}
exports.getSeatsOfZone = getSeatsOfZone;
function createSeats(seats) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.post("/Seats", seats);
        return response.data;
    });
}
exports.createSeats = createSeats;
function updateSeats(seats) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.put("/Seats", seats);
        return response.data;
    });
}
exports.updateSeats = updateSeats;
function updateStatusOfSeats(eventId, seatIds, seatStatus) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.post("/Seats/Status", { eventId, seatIds, seatStatus });
        return response.data;
    });
}
exports.updateStatusOfSeats = updateStatusOfSeats;
function addTicketTypeToSeats(seatIds, ticketTypeId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.post("/Seats/TicketType", { seatIds, ticketTypeId });
        return response.data;
    });
}
exports.addTicketTypeToSeats = addTicketTypeToSeats;
function removeTicketTypeFromSeats(seatIds, ticketTypeId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.delete("/Seats/TicketType", { data: { seatIds, ticketTypeId } });
        return response.data;
    });
}
exports.removeTicketTypeFromSeats = removeTicketTypeFromSeats;
function deleteSeats(seatIds) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.delete("/Seats", { data: seatIds });
        return response.data;
    });
}
exports.deleteSeats = deleteSeats;
/**
 * SeatStatus
 */
function getSeatStatuses(languageCode) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get("/SeatStatuses", {
            params: { languageCode },
        });
        return response.data;
    });
}
exports.getSeatStatuses = getSeatStatuses;
/**
 * SeatMapShapes
 */
function getSeatMapShapes() {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get("/SeatMapShapes");
        return response.data;
    });
}
exports.getSeatMapShapes = getSeatMapShapes;
/**
 * ZoneEvent
 */
function getZoneEventsOfEvent(zoneId, eventId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/Zone/${zoneId}/Event/${eventId}`);
        return response.data;
    });
}
exports.getZoneEventsOfEvent = getZoneEventsOfEvent;
function createZoneEvent(zoneId, ticketTypeId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.post("/ZoneEvent", { zoneId, ticketTypeId });
        return response.data;
    });
}
exports.createZoneEvent = createZoneEvent;
function deleteZoneEvent(zoneEventId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.delete(`/ZoneEvent/${zoneEventId}`);
        return response.data;
    });
}
exports.deleteZoneEvent = deleteZoneEvent;
/**
 * SeatMapShapeZone
 */
function getSeatMapShapesOfZone(zoneId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/Zone/${zoneId}/SeatMapShapes`);
        return response.data;
    });
}
exports.getSeatMapShapesOfZone = getSeatMapShapesOfZone;
/**
 * TransactionTypes
 */
function getTransactionTypes() {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get("/TransactionTypes");
        return response.data;
    });
}
exports.getTransactionTypes = getTransactionTypes;
/**
 * EventCalculations
 */
function getEventCalculationEvents(organizerId, languageCode) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/EventCalculation/Events?organizerId=${organizerId}&languageCode=${languageCode}`);
        return response.data;
    });
}
exports.getEventCalculationEvents = getEventCalculationEvents;
/**
 * RevenueGroups
 */
function getRevenueGroups() {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios_instance_1.api.get(`/RevenueGroups`);
        return response.data;
    });
}
exports.getRevenueGroups = getRevenueGroups;
